const React = require("react");

function CurrencyBangladeshiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = CurrencyBangladeshiIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/CurrencyBangladeshiIcon.js
 ** module id = 495
 ** module chunks = 0
 **/